export default __webpack_public_path__ + "static/media/home3.34780b89.png";